import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Input from "components/Elements/Input";
// import Select from "components/Elements/Select";
// import Select from "react-select";
import { saveClient, getClient } from "actions/clients";
import { saveUser } from "actions/users";
import styled from "styled-components";
// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const Client = ({ navigation }) => {
  const navigate = useNavigate();
  const { client_id } = useParams();
  const dispatch = useDispatch();
  const { client, saving } = useSelector((state) => state.clients);
  const [clientUsers, setClientUsers] = useState([]);
  const [localClient, setLocalClient] = useState(client);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const usersHead = [
    "public_id",
    "email",
    "firstname",
    "lastname",
    "user_type",
    "comped",
  ];

  useEffect(() => {
    if (client_id && (client === null || localClient === null)) {
      setLoading(true);
      dispatch(getClient(client_id));
    } else if (!client_id) {
      setLoading(false);
      setLocalClient(null);
    }

    return () => {
      setLocalClient(null);
      setLoading(true);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (client_id) {
      setLoading(true);
      dispatch(getClient(client_id));
    } else {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client_id]);

  useEffect(() => {
    if (client && client_id === client.public_id) {
      setLoading(false);
      setLocalClient({ ...client });
      console.log(client.users);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  useEffect(() => {
    if (!localClient) return;
    setClientUsers(
      localClient.users.map((u) => [
        u.public_id,
        u.email,
        u.firstname,
        u.lastname,
        u.user_type,
        <div>
          <select
            name="comped"
            value={u.comped_subscription}
            onChange={(e) => {
              console.log("!!! ON CHANGE: ", e.target.value);
              const newClient = { ...localClient };
              newClient.users = newClient.users.map((user) => {
                if (user.public_id === u.public_id) {
                  user.comped_subscription = e.target.value === "true";
                  console.log("UPDATED USER: ", user);
                  saveClientUser(user);
                }
                return user;
              });
              setLocalClient(newClient);
            }}
          >
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>,
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localClient]);

  if (loading) {
    return (
      <>
        <Sidebar {...sidebar} />
        <div
          className="relative md:ml-64 bg-blueGray-100 pt-24"
          style={{ height: "100%", minHeight: "100vh" }}
        >
          <div style={{ marginLeft: "50px" }}>Loading Client...</div>
        </div>
      </>
    );
  }

  const handleChange = ({ target }) => {
    const u = { ...client };
    u[target.name] = target.value;
    setLocalClient(u);
  };

  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    const clientNameValid = localClient.name && localClient.name.length > 0;
    errors.Name = clientNameValid ? "" : " is required";

    console.log("errors: ", errors);
    setFormErrors(errors);

    return clientNameValid;
  };

  const save = () => {
    if (validateFields()) {
      dispatch(saveClient(localClient));
    }
  };

  const saveClientUser = (user) => {
    dispatch(saveUser(user));
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div>
            <div className="relative p-6 flex-auto ">
              <div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/admin/clients");
                  }}
                >
                  <i className="fa fa-arrow-left" /> Back to Clients
                </div>{" "}
              </div>
              <h3 className="text-3xl font-semibold">
                {localClient.id ? "Edit Client" : "Add Client"}
              </h3>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <label>ID</label>
                <Input
                  label="ID"
                  placeholder="ID"
                  name="id"
                  value={localClient.id ?? ""}
                  disabled
                />
                <label>Public ID</label>
                <Input
                  label="Public ID"
                  placeholder="Public ID"
                  name="public_id"
                  value={localClient.public_id ?? ""}
                  disabled
                />
                <label>
                  Name <ErrorField>{formErrors.name}</ErrorField>
                </label>
                <Input
                  label="Name"
                  placeholder="Name"
                  name="name"
                  value={localClient.name ?? ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i> Saving...
                  </>
                ) : (
                  <>Save Changes</>
                )}
              </button>
            </div>
            <div className="w-full px-4">
              <CardFullTable
                title="Users"
                titlebutton={
                  <i
                    onClick={() => {}}
                    className="fa fa-plus text-sm cursor-pointer"
                  />
                }
                head={usersHead}
                body={clientUsers}
                onRowClick={(row) => {}}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Client;
